import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {ProjectRoutingModule} from './project-routing.module';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

import {SharedModule} from '../shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';

import {ProjectListComponent} from '@app/modules/project/project-list';
import {ProjectAddComponent} from '@app/modules/project/project-add';
import {AddInfluencerComponent} from '@app/modules/project/add-influencer';
import {InfluencerAddComponent} from '@app/modules/project/influencer-add';
import {InfluencerViewComponent} from '@app/modules/project/influencer-view';
import {ImportInfluencerComponent} from './import-influencer';
import {ShareProjectComponent} from './share-project';
import {AwsService} from '@app/services/aws.service';
import {ToastrModule} from 'ngx-toastr';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {StatusBarModule} from '@app/modules/status-bar/status-bar.module';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ColorPickerModule} from 'ngx-color-picker';
import {FontPickerModule} from '@app/modules/fontPicker/fontPicker.module';
import {InfluencerModule} from '@app/modules/influencer/influencer.module';
import {ProjectCopyComponent} from './project-copy/project-copy.component';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {WidgetInstructionsComponent} from './widget-instrcutions/widget-instructions.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {AceEditorModule} from 'ng2-ace-editor';
import {ThirdpartyPlatformsComponent} from '@app/modules/project/thirdparty-platforms-view';
import {WidgetAvatarTemplatesComponent} from "@app/modules/project/widget-avatar-templates/widget-avatar-templates.component";
import {
  InfluencerAutoJoinComponent,
  ShareWidgetAccessSecurityComponent,
  ShareWidgetAccessTabComponent
} from './influencer-auto-join-view';
import {UnifiedFormControlsModule} from '@app/_components/unified/unified-form-controls.module';
import {CKEditorModule} from 'ckeditor4-angular';
import {WidgetCustomizationAiModule} from '@app/_components/widget-customization-ai/widget-customization-ai.module';
import {AnonymizeScopeChoiceComponent} from '@app/modules/data-protection/anonymize-scope-choice/anonymize-scope-choice.component';

@NgModule({
  declarations: [
    ProjectListComponent,
    ProjectAddComponent,
    InfluencerViewComponent,
    ImportInfluencerComponent,
    ThirdpartyPlatformsComponent,
    AddInfluencerComponent,
    InfluencerAddComponent,
    ShareProjectComponent,
    ProjectCopyComponent,
    WidgetInstructionsComponent,
    WidgetAvatarTemplatesComponent,
    InfluencerAutoJoinComponent,
    ShareWidgetAccessTabComponent,
    ShareWidgetAccessSecurityComponent
  ],
  providers: [AwsService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProjectRoutingModule,
    DataTablesModule,
    NgxMaterialTimepickerModule,
    BsDatepickerModule,
    SharedModule,
    ToastrModule,
    StatusBarModule,
    FontAwesomeModule,
    TabsModule,
    AccordionModule.forRoot(),
    PaginationModule.forRoot(),
    DragDropModule,
    MatMenuModule,
    ColorPickerModule,
    FontPickerModule,
    InfluencerModule,
    NgbPopoverModule,
    PopoverModule.forRoot(),
    MatIconModule,
    MatTooltipModule,
    AceEditorModule,
    UnifiedFormControlsModule,
    CKEditorModule,
    WidgetCustomizationAiModule,
    AnonymizeScopeChoiceComponent
  ]
})
export class ProjectModule {
}
